import apiRequest from "../../helpers/apiRequest";

export default async (slug, date) => {
    return await apiRequest({
        method: 'get',
        url: `content/participant/count/${slug}/${date}`,
    })
}
